import * as React from "react";
import { Grid, Menu, Divider, Segment, Button, Card, Tab, Loader } from "semantic-ui-react";

import { Detail } from "@neworbit/simpleui-detail";
import { useDispatch, useSelector } from "@teamprevent/admin-redux";
import { Authorize } from "reauthorize";

import { ConfirmedButton } from "@teamprevent/common/confirmedButton/ConfirmedButton";

import { teamSelector, basePathSelector, routeIdSelector } from "../selectors";
import { AppState } from "../model";
import { deleteTeam, loadTeamDetail } from "../actions";
import { ADMIN_ROLES } from "../../auth";

import { Link } from "redux-little-router";

export const Details = () => {
    const teamId = useSelector(routeIdSelector);
    const path = useSelector((state: AppState) => state.router.pathname);
    const team = useSelector(teamSelector);
    const basePath = useSelector(basePathSelector);
    const dispatch = useDispatch();
    const onDelete = React.useCallback(() => dispatch(deleteTeam(team.id, basePath)), [basePath, dispatch, team.id]);

    React.useEffect(() => {
        dispatch(loadTeamDetail({ teamId }));
    }, [dispatch, teamId]);

    if ("email" in team) {
        return (
            <Grid container className="nomargintop">
                <Grid.Row>
                    <Grid.Column>
                        <h1>{team.name}</h1>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={3} as={Grid} padded>
                        <Grid.Column vertical as={Menu}>
                            <Menu.Item name="AdminUsers" as={Link} href="/teams">
                                All Teams
                            </Menu.Item>
                        </Grid.Column>
                    </Grid.Column>

                    <Grid.Column width={13}>
                        <Card fluid>
                            <Tab.Pane>
                                <Grid>
                                    <Detail label="Name" value={team.name} labelWidth={5} valueWidth={11} />
                                    <Detail label="Email" value={team.email} labelWidth={5} valueWidth={11} />
                                    <Detail label="Phone Number" value={team.phoneNumber} labelWidth={5} valueWidth={11} />
                                    <Detail
                                        label="Customers"
                                        value={team.customers.map(customer => customer.name).join(", ")}
                                        labelWidth={5}
                                        valueWidth={11}
                                    />
                                    <Detail
                                        label="Leaders"
                                        value={team.leaders.map(leader => leader.name).join(", ")}
                                        labelWidth={5}
                                        valueWidth={11}
                                    />
                                    <Detail
                                        label="Members"
                                        value={team.members.map(member => member.name).join(", ")}
                                        labelWidth={5}
                                        valueWidth={11}
                                    />
                                </Grid>
                            </Tab.Pane>
                        </Card>
                        <Divider />
                        <Segment basic clearing vertical>
                            <Authorize authorize={[ADMIN_ROLES.SYSTEM_ADMIN.name]}>
                                <ConfirmedButton
                                    icon="delete"
                                    content="Delete"
                                    floated="left"
                                    className="warning"
                                    onClick={onDelete}
                                    promptText="Are you sure you want to delete this team? Type 'DELETE' and click confirm to delete."
                                    typeToConfirmText="DELETE"
                                    headingText="Delete Team"
                                />
                                <Button icon="pencil" content="Edit" floated="right" as={Link} href={`${path}/edit`} />
                            </Authorize>
                        </Segment>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }

    return <Loader active />;
};
